module.exports = __webpack_public_path__ + "img/400.e547c62a.jpg";